import ColumnCommon from '@/commons/wildcards/constants/ColumnCommon';
import {MSConstant} from '@/commons/wildcards';
import ErrorCode from '@/commons/wildcards/constants/ErrorCodes';
export class BaseStore {
  constructor(api) {
    const me = this;
    me.state = {
      items: [],
      loading: false,
      payload: null,
      total: 0,
      summary: null,
      // Kết quả của hàm loadSummary
      // mặc dù ở hàm loadSummary, summary đã gán bằng kết quả nhưng sau đó đã được set lại
      summaryRes: null,
      _config: {},
      layout: [],
    };

    me.action = {
      /**
       * Lấy dữ liệu phân trang
       * @param {Object} payload thông tin query
       */
      async getPaging(payload) {
        const me = this;
        let res = null;

        try {
          me.loading = true;
          if (typeof api.getPaging !== 'function') {
            throw new Error('Api getPaging not found');
          }
          res = await api.getPaging(payload || {});
          this.setPaging(res);
        } finally {
          me.loading = false;
        }
        return res;
      },
      /**
       * Load dữ liệu để thêm/sửa/nhân bản
       * Hàm này sẽ không commit mà return value để binding cho form
       */
      async getItem(payload) {
        const method = 'get' + payload.action;
        delete payload.action;
        if (typeof api[method] !== 'function') {
          throw new Error(`Api ${method} not found`);
        }
        const res = await api[method](payload);
        return res;
      },
      /**
       * Lấy dữ liệu dòng tổng
       * @param {Object} payload Thông tin query
       * @return dữ liệu từ server
       */
      async getPagingSummary(payload) {
        let res = null;
        try {
          if (typeof api.getPagingSummary !== 'function') {
            throw new Error('Api getPagingSummary not found');
          }
          res = await api.getPagingSummary(payload || {});
          this.summary = res;
          this.summaryRes = res;
        } finally {
          if (res) {
            this.setPaging(res);

            // NVTUYEN 09.06.2023 thực hiện sửa lại cho đúng thám số đầu vào
            this.setPayload(payload);
          }
        }
        return res;
      },

      /**
       * Load dữ liệu tree (lấy full theo filter)
       * @param {*} payload
       */
      async getTreeItems(payload) {
        const me = this;
        try {
          me.loading = true;
          if (typeof api.getTree !== 'function') {
            throw new Error('Api getTree not found');
          }
          const res = await api.getTree(payload || {});
          if (Array.isArray(res)) {
            me.items = res;
          }
        } finally {
          me.loading = false;
        }
      },
      /**
       * Lấy bản ghi theo id
       */
      async getItemByIds(payload) {
        if (typeof api.getItemByIds !== 'function') {
          throw new Error('Api getItemByIds not found');
        }
        return await api.getItemByIds(payload || {});
      },
      /**
       * Lấy full dữ liệu => hạn chế dùng hàm này, chỉ dùng khi bắt buộc
       */
      async getItems(payload) {
        const me = this;
        let res = [];
        try {
          this.loading = true;
          if (typeof api.getItems !== 'function') {
            throw new Error('Api getItems not found');
          }
          res = await api.getItems(payload || {});
        } finally {
          this.loading = false;
        }
        return res;
      },
      /**
       * Insert dữ liệu
       * @param {*} payload
       * @returns
       */
      async insert(payload) {
        const me = this;
        if (typeof api.insert !== 'function') {
          throw new Error('Api insert not found');
        }
        const res = await api.insert(payload);
        if (res) {
          this.insertItems(payload, res);
        }
        return res;
      },
      /**
       * Update dữ liệu
       * @param {*} payload
       */
      async update(payload) {
        if (typeof api.update !== 'function') {
          throw new Error('Api update not found');
        }
        const res = await api.update(payload);
        this.updateItem(res, payload);
        return res;
      },

      /**
       * Xóa dữ liệu
       * @param {X} payload
       */
      async delete(payload) {
        if (typeof api.delete !== 'function') {
          throw new Error('Api delete not found');
        }
        const res = await api.delete(payload);

        this.afterDeleteSuccess(payload, res);

        this.deleteItems(payload, res);
        return res;
      },

      /**
       * Xử lý sau khi xóa thành công (cập nhật giá trị trong store hoặc store khác)
       * @param {*} payload tham số
       * @param {*} res kết quả xóa
       * NXCHIEN 19.03.2024
       */
      afterDeleteSuccess(payload, res) {},

      /**
       * setPaging
       * @param {*} data
       */
      setPaging(data) {
        if (data) {
          for (const i in data) {
            const resultValue = data[i];
            switch (i) {
              case 'Data':
                this.items = resultValue;
                break;
              case 'Total':
                this.total = resultValue;
                break;
              case 'SummaryData': {
                this.summary = resultValue;
                break;
              }
            }
          }
        }
      },

      /**
       * setPayload
       * @param {*} payload
       */
      setPayload(payload) {
        this.payload = payload;
      },

      /**
       * Cập nhật ngược vào list
       * @param {Object} item
       */
      updateItem(data, payload) {
        const keyField = this._config?.field.key;
        if (keyField) {
          this.beforeUpdateItems(data, payload);
          const id = data[keyField];
          for (let i = 0; i < this.items.length; i++) {
            const item = this.items[i];
            if (item[keyField] === id) {
              // Check xem nếu có thay đổi ở cấu trúc tree thì thì assign lại data để thực hiện build lại cấu trúc
              // NCPHUOC 08/07/2022
              // NCPHUOC 02.06.2023 thay check item.hasOwnProperty(ColumnCommon.parentId) -> this._config?.isTree cho trường hợp dạng Tree
              if (this.$state._config.isTree && item['parent_id'] !== data['parent_id']) {
                // check nếu res data không có prop parent_id thì gán thêm nó vào data
                // PCKIEN 02.06.2023
                !data.hasOwnProperty('parent_id') ? (data.parent_id = '') : null;

                Object.assign(item, data);
                this.items = [...this.items];
              } else {
                // gán lại STT
                if (item && item['sort_order']) {
                  data['sort_order'] = item['sort_order'];
                }

                Object.assign(item, data);
              }
              break;
            }
          }
        }
      },
      /**
       * hàm thực hiện update lại dữ liệu khi thêm
       */
      insertItems(payload, res) {
        const me = this;
        this.beforeInsertItems(payload, res);
        if (Array.isArray(res)) {
          me.items = [...me.items, ...res];
          // Tính toán lại tổng số bản ghi
          me.total += res.length;
        } else {
          me.items = [...me.items, res];
          // Tính toán lại tổng số bản ghi
          me.total = me.total + 1;
        }
      },

      /**
       * Cập nhật ngược vào list khi xóa
       * @param {*} res
       * @returns
       */
      deleteItems(payload, res) {
        const models = payload.Models;
        const errorCodes = Object.values(ErrorCode);
        const key = this._config?.field.key;

        const mapDeleteError = {};

        if (Array.isArray(res)) {
          res.forEach(item => {
            if (errorCodes.some(y => y === item.Code)) {
              const itemError = models[item.Index];
              mapDeleteError[itemError[key]] = true;
              return true;
            }
          });
        }

        const removeItems = models.filter(x => !mapDeleteError.hasOwnProperty(x[key]));

        if (removeItems.some(x => x)) {
          this.items = this.items?.filter(x => !removeItems.some(y => y[key] === x[key]));
          // Tính toán lại tổng số bản ghi
          this.total = this.total - removeItems.length;
        }
        return removeItems;
      },

      /**
       * xử lý trước khi update item
       */
      beforeUpdateItems(data, payload) {},

      /**
       * xử lý trước khi insert item
       */
      beforeInsertItems(payload, res) {},
    };

    me.getters = {};
  }
}
